module.exports = __webpack_public_path__ + "img/b1.79d84522.png";